import Vue from 'vue';
import { mapGetters } from 'vuex';
import DropletOptions from '../_bubble-options';
import CodeGeneralOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('code-general', {
  template: require('./template.html'),
  computed: {
    ...mapGetters(['currentPage']),
    profile() {
      return this._dropletType(this.droplet);
    },
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-wide',
      showEditBubble: false,
    };
  },
  name: 'code-general',
  props: ['block-index', 'droplet', 'items', 'index', 'canvas'],
  components: {
    DropletOptions,
    CodeGeneralOptions,
  },
  methods: {
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/code-general/index.js